import { render } from "./AddNews.vue?vue&type=template&id=36c01812"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"
script.render = render

export default script